import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getUserEmails: function ({page = 1, limit = 100, search, sort, tags, threadId}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (sort) query.push(`sort[]=${sort}`)
    if (search) query.push(`search=${search}`)
    if (tags) query.push(`tags[]=${tags}`)
    if (threadId) query.push(`googleId[]=${threadId}`)
    const route = search ? 'useremails' : 'useremails/withoutelastic'
    return instCred.get(route + '?' + query.join('&'))
  },
  createUserEmails: function (email) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('useremails/', email)
  },
  updateUserEmails: function (email) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.put('useremails/' + email.id, email)
  },
  deleteUserEmails: function (emailId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('useremails/' + emailId)
  }
}



// WEBPACK FOOTER //
// ./src/api/UserEmails/api.js